import React from 'react';
import styles from './StatCard.module.css';

function StatCard({ label, value, tone }) {
  const toneClass = tone ? styles[tone] : '';
  return (
    <div className={styles.card}>
      <div className={`${styles.value} ${toneClass}`}>{value}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}

export default StatCard;
